import React, { useMemo, useCallback } from 'react';
import { useHistory } from 'react-router';
import cx from 'clsx';
import { WiderTable } from '@/components';
import { getColumns } from './columns';
import { UnionBadge } from '../../types';
import style from './index.module.scss';

type Props = {
  data: (UnionBadge & { has_minted: boolean })[] | undefined;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
  className?: string;
  showBadgeIssuedInfo?: boolean;
};

export const BadgeList = ({
  data,
  isLoading,
  isError,
  refetch,
  className,
  showBadgeIssuedInfo,
}: Props) => {
  const history = useHistory();
  const columns = useMemo(() => getColumns(showBadgeIssuedInfo), [showBadgeIssuedInfo]);

  const onRowClick = useCallback(
    row => {
      const id = row?.id;
      const isOfficialBadge = !!row?.official_id;
      if (id) {
        history.push(`${isOfficialBadge ? '/official-badge' : '/badge'}/${id}`);
      }
    },
    [history],
  );

  return (
    <WiderTable
      onRowClick={onRowClick}
      columns={columns}
      data={data}
      reload={refetch}
      loading={isLoading}
      isError={isError}
      skeleton
      className={cx(style.table, className)}
    />
  );
};
